"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globalEventTracker = require("./global-event-tracker");

Object.keys(_globalEventTracker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _globalEventTracker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _globalEventTracker[key];
    }
  });
});